import { SurveyQuestion as ReactSurveyQuestion } from 'survey-react-ui';
import { Question } from 'survey-core';

import { OVERWRITTEN_TYPE } from '../Survey.const';

export class SurveyQuestion extends ReactSurveyQuestion {
  protected renderHeader(question: Question): JSX.Element {
    if (OVERWRITTEN_TYPE.includes(this.question.getType())) {
      return null;
    }
    return super.renderHeader(question);
  }

  protected renderErrors(cssClasses: any, location: string): JSX.Element {
    if (OVERWRITTEN_TYPE.includes(this.question.getType())) {
      return null;
    }
    return super.renderErrors(cssClasses, location);
  }

  protected renderComment(cssClasses: any): JSX.Element {
    if (OVERWRITTEN_TYPE.includes(this.question.getType())) {
      return null;
    }
    return super.renderComment(cssClasses);
  }

  protected renderDescription(): JSX.Element {
    if (OVERWRITTEN_TYPE.includes(this.question.getType())) {
      return null;
    }
    return super.renderDescription();
  }

  protected renderQuestionContent(): JSX.Element {
    return this.renderQuestion();
  }

  render(): JSX.Element {
    if (OVERWRITTEN_TYPE.includes(this.question.getType())) {
      return this.renderQuestionContent();
    }
    return super.render();
  }
}
